import React from 'react';
import { Outlet } from 'react-router-dom';
import MainWrapper from 'src/Layout/MainWrapper';
import PrivateRoute from './PrivateRoute';

const AuthenticatedLayout = () => (
  <PrivateRoute>
    <MainWrapper>
      <Outlet />
    </MainWrapper>
  </PrivateRoute>
);

export default AuthenticatedLayout;
